/**
 * Every grid appends its next page the same way: what is already shown stays
 * in place, and an incoming listing whose id is already shown is dropped. A
 * page can repeat listings (the shuffle seed changes on a reload, a fallback
 * page draws from the same pool, two loads race), and a repeat on screen
 * reads as a broken feed.
 *
 * Ids compare as strings: search rows carry numbers, products carry strings.
 */
export function appendUnique<T extends { id?: unknown }>(shown: readonly T[], incoming: readonly T[]): T[] {
  const seen = new Set(shown.map(item => String(item.id)));
  const fresh: T[] = [];
  for (const item of incoming) {
    const key = String(item.id);
    if (seen.has(key)) continue;
    seen.add(key);
    fresh.push(item);
  }
  return fresh.length === 0 ? [...shown] : [...shown, ...fresh];
}
